export function regionDisplayName(countryCode: string | null | undefined, language: string): string {
    const normalizedCode = countryCode?.trim().toUpperCase();
    if (!normalizedCode) {
        return "";
    }

    try {
        return new Intl.DisplayNames([language], { type: "region" }).of(normalizedCode) || normalizedCode;
    } catch {
        return normalizedCode;
    }
}

export function localizeRegionDisplayNames(root: ParentNode, language: string): void {
    const elements = root instanceof HTMLElement && root.matches("[data-country-code]")
        ? [root, ...root.querySelectorAll<HTMLElement>("[data-country-code]")]
        : [...root.querySelectorAll<HTMLElement>("[data-country-code]")];

    elements.forEach(element => {
        const name = regionDisplayName(element.dataset.countryCode, language);
        element.textContent = element.hasAttribute("data-country-name-uppercase")
            ? name.toLocaleUpperCase(language)
            : name;
    });
}
